<script setup>
import { useI18n } from 'vue-i18n';
import LaisField from 'dashboard/components-next/LaisField.vue';
import { formatAttachmentSize } from '../utils/supportTicketPortal';

defineProps({
  attachments: { type: Array, default: () => [] },
  limitLabel: { type: String, default: '' },
});

const emit = defineEmits(['change', 'remove']);

const { t } = useI18n();
</script>

<template>
  <LaisField
    :label="t('SUPPORT_TICKETS.ATTACHMENTS.LABEL')"
    :helper="
      t('SUPPORT_TICKETS.ATTACHMENTS.HELPER', {
        limit: limitLabel,
      })
    "
  >
    <input
      type="file"
      multiple
      accept="image/*,application/pdf,.doc,.docx,.txt"
      class="text-[13px] text-lais-text"
      @change="emit('change', $event)"
    />
    <div v-if="attachments.length" class="mt-2 grid gap-2">
      <div
        v-for="(file, index) in attachments"
        :key="`${file.name}-${file.size}-${index}`"
        class="flex items-center justify-between gap-3 rounded-lais border border-lais-border-soft bg-white px-3 py-2 text-[12px]"
      >
        <span class="flex min-w-0 items-center gap-2">
          <span
            class="size-4 shrink-0"
            :class="
              file.type.startsWith('image/')
                ? 'i-lucide-image'
                : 'i-lucide-file-text'
            "
            aria-hidden="true"
          />
          <span class="truncate">{{ file.name }}</span>
          <span class="shrink-0 text-lais-text-muted">
            {{ formatAttachmentSize(file.size) }}
          </span>
        </span>
        <button
          type="button"
          class="i-lucide-x size-4 shrink-0 text-lais-text-muted"
          :aria-label="t('SUPPORT_TICKETS.ATTACHMENTS.REMOVE')"
          @click="emit('remove', index)"
        />
      </div>
    </div>
  </LaisField>
</template>
